export default {
  harassment: {
    create: {
      ingress:
        'Ici, tu as la possibilité de nous en dire plus sur ce que tu as vu ou vécu chez {organizationTitle}. Nous tenons à te remercier pour ton aide à assurer la sécurité sur notre lieu de travail.',
      instructions:
        "Rédige ton rapport dans la zone de texte ci-dessous. Tu peux choisir d'inclure ton adresse e-mail dans le rapport ou de rester anonyme. Que tu choisisses de rester anonyme ou non, tu pourras revenir sur ton dossier et en assurer le suivi après avoir soumis ton rapport.",
      instructions1:
        "Tu recevras une confirmation de l'envoi du rapport, un identifiant et un mot de passe que tu pourras utiliser, que tu restes anonyme ou non, pour revenir ultérieurement et suivre l'affaire.",
      instructions2:
        "Les rapports seront envoyés aux administrateurs désignés chez {organizationTitle}. Aucune autre personne ne pourra lire le rapport que tu as envoyé. Si tu as indiqué une adresse e-mail, tu seras informé des changements de statut de l'affaire et des éventuelles questions que te posera la société. Nous respecterons alors la confidentialité de ton identité et ne la révélerons que si cela est nécessaire pour l'affaire.",
      instructionsHeader: 'Comment cela fonctionne-t-il ?',
      options: {
        confirmNotToIncludeEmail:
          "Je suis conscient(e) qu'en n'indiquant pas mon adresse e-mail, je renonce à la possibilité d'être informé(e) lorsque le statut de mon dossier évoluera et que la société destinataire ne connaîtra pas mon identité.",
        includeEmail: 'Je souhaite inclure mon adresse e-mail'
      }
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          "Après avoir soumis le rapport, tu ne pourras plus le lire ou le modifier pour des raisons de sécurité. Toutefois, tu pourras revenir plus tard et suivre l'état d'avancement de l'affaire, voir les éventuelles questions de suivi de {organizationTitle} et les compléter toi-même anonymement, avec des informations supplémentaires.",
        confirmDescriptionEmailIncluded:
          "Comme tu as choisi d'inclure ton adresse e-mail, nous te contacterons {email} lorsque le dossier sera ouvert et si nous avons des questions à te poser. Merci de vérifier ton rapport ci-dessous avant de le soumettre.",
        confirmDescriptionEmailNotIncluded:
          "Tu as choisi de ne pas inclure d'adresse e-mail avec ton rapport, nous ne pourrons donc pas te contacter. Vérifie le rapport ci-dessous avant de le soumettre.",
        createDescription: 'Merci de rédiger ton descriptif ici :',
        placeholder: 'Je voudrais signaler...',
        reporterGuide: {
          question1: "Qu'est-ce qui te préoccupe ?",
          question2: "Quand cela s'est-il produit ?",
          question3: 'Quelles sont les personnes impliquées ?',
          question4: "Où cela s'est-il produit ?",
          question5: 'As-tu donné tous les détails ?',
          question6: 'Tu peux ajouter une image si tu le souhaites',
          title: "Guide pour la rédaction d'un rapport"
        },
        responseDescriptionEmailIncluded:
          'Tu recevras une notification par e-mail quand le dossier sera ouvert par un administrateur.'
      }
    },
    title: 'Faire un rapport à {organizationTitle}'
  },
  whistleblower: {
    alerts: {
      notValidLink: ' Merci de suivre un lien valide pour accéder à cette page.'
    },
    buttons: {
      back: 'Revenir en arrière',
      continue: 'Continuer',
      noOption: 'Non',
      send: 'Envoyer un rapport',
      yesOption: 'Oui'
    },
    confirm: {
      title: {
        reportNotSent: "Le rapport n'a PAS été envoyé !"
      }
    },
    create: {
      email: {
        help:
          "Si tu choisis de joindre un e-mail à ton rapport, nous te contacterons pour te tenir au courant de l'évolution de la situation ou si nous avons des questions. L'ajout d'une adresse e-mail est volontaire.",
        label: 'E-mail:',
        placeholder: 'Saisis ton e-mail ici'
      },
      ingress:
        "Ici, tu as la possibilité de signaler tout comportement répréhensible dont tu as connaissance, ou que tu soupçonnes qui s'est produit ou qui se produira chez {organizationTitle}. Ce canal ne doit être utilisé que pour signaler des cas de comportement répréhensible dans des situations liées au travail et uniquement si tu as des raisons de penser que tes informations sont vraies.",
      instructions:
        "Tu dois d'abord choisir comment tu souhaites présenter ton rapport. Tu peux également choisir d'inclure ton adresse e-mail dans le rapport ou de rester anonyme. Que tu choisisses de rester anonyme ou non, tu pourras revenir sur ton dossier et en assurer le suivi après avoir soumis ton rapport.",
      instructions1:
        "Tu recevras ensuite une confirmation de l'envoi du rapport, un identifiant et un mot de passe que tu pourras utiliser, que tu sois anonyme ou non, pour revenir plus tard et suivre l'affaire. Même si tu choisis de faire un rapport lors d'une réunion ou par téléphone, tu peux également suivre l'affaire de manière numérique si tu le souhaites.",
      instructions2:
        "Les rapports seront envoyés aux administrateurs désignés chez {organizationTitle}. Aucune autre personne ne pourra lire le rapport que tu as envoyé. Si tu as indiqué une adresse e-mail, tu seras informé des changements de statut de l'affaire et des éventuelles questions que te posera la société. Nous respecterons alors la confidentialité de ton identité et ne la révélerons que si cela est nécessaire pour l'affaire.",
      instructionsHeader: 'Comment cela fonctionne-t-il ?',
      options: {
        confirmNotToIncludeEmail:
          "Je comprends qu'en n'indiquant pas mon adresse e-mail, je renonce à la possibilité d'être informé(e) lorsque le statut de mon affaire change, car la société destinataire ne sait pas qui je suis.",
        includeEmail: 'Je souhaite inclure mon adresse e-mail'
      }
    },
    followup: {
      buttons: {
        submit: "Récupérer l'affaire"
      },
      messages: {
        buttons: {
          send: {
            help:
              "Tu peux envoyer un message de suivi qui sera lu par les représentants de la société destinataire. Personne d'autre ne peut lire ton message.",
            title: 'Envoyer un message'
          }
        },
        messageSent: 'Merci pour ton message !',
        placeholder: 'Saisir un message ici',
        reporter: 'Rapporteur',
        title: 'Messages',
        writtenByAdmin: 'Admin'
      },
      status: {
        new: {
          description: 'Ton rapport a été reçu et sera examiné sous peu.',
          title: 'Nouveau'
        },
        open: {
          description:
            "Ton rapport a été reçu et est en cours d'examen. Merci de revenir plus tard pour de nouvelles informations. Si tu as communiqué tes coordonnées, nous te contacterons.",
          title: 'Ouvrir'
        },
        solved: {
          description:
            "Ton rapport a été traité et l'enquête est maintenant terminée. Si tu as communiqué tes coordonnées, nous te contacterons pour te donner plus de détails.",
          title: 'Résolu'
        }
      },
      statusLabel: "L'affaire a le statut :",
      title: 'Affaire {caseName}'
    },
    followupLogin: {
      caseLabel: "ID de l'affaire :",
      passwordLabel: 'Mot de passe :',
      title: "Suivi de l'affaire"
    },
    messages: {
      error: {
        failedToSendReport: "Le rapport n'a pas pu être envoyé",
        organizationNotFound:
          "Nous n'avons pas trouvé de société à laquelle envoyer ton rapport. Merci de t'assurer que tu as suivi un lien valide pour accéder à cette page.",
        whistleblowerInfoNotFound:
          'Impossible de trouver des informations pour faire un rapport à cette société.'
      }
    },
    received: {
      bottomWarning:
        "Remarque ! C'est la seule occasion pour toi de voir les informations ci-dessus, alors enregistre-les maintenant !",
      caseLabel: "ID de l'affaire :",
      linkLabel: 'Lien',
      passwordLabel: 'Mot de passe :',
      title: 'Rapport reçu !',
      topWarning:
        'Merci de conserver les informations ci-dessous en toute sécurité !'
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          "Après avoir soumis le rapport, tu ne pourras plus le lire ou le modifier pour des raisons de sécurité. Toutefois, tu pourras revenir plus tard et suivre l'état d'avancement de l'affaire, voir les éventuelles questions de suivi de {organizationTitle} et les compléter toi-même anonymement, avec des informations supplémentaires.",
        confirmDescriptionEmailIncluded:
          "Comme tu as choisi d'inclure ton adresse e-mail, nous te contacterons {email} lorsque le dossier sera ouvert et si nous avons des questions à te poser. Merci de vérifier ton rapport ci-dessous avant de le soumettre.",
        confirmDescriptionEmailNotIncluded:
          "Tu as choisi de ne pas inclure d'adresse e-mail avec ton rapport, nous ne pourrons donc pas te contacter. Vérifie le rapport ci-dessous avant de le soumettre.",
        createDescription:
          "Décris ce qui s'est passé et pourquoi tu souhaites le signaler. Ne communique pas de renseignements personnels, sauf s'ils sont utiles à l'affaire.",
        label:
          'Je souhaite faire un rapport par voie numérique via ce formulaire',
        placeholder: 'Je voudrais signaler...',
        reporterGuide: {
          question1: "Qu'est-ce qui te préoccupe ?",
          question2: "Quand cela s'est-il produit ?",
          question3: 'Quelles sont les personnes impliquées ?',
          question4: "Où cela s'est-il produit ?",
          question5: 'As-tu donné tous les détails ?',
          question6: 'Tu peux ajouter une image si tu le souhaites',
          title: "Guide pour la rédaction d'un rapport"
        },
        responseDescriptionEmailIncluded:
          "Tu recevras une notification par e-mail dès que le dossier sera ouvert par l'un des administrateurs. Le délai est de 7 jours. Après l'ouverture du dossier, l'enquête sera menée dans un délai de trois mois.",
        responseDescriptionEmailNotIncluded:
          "Étant donné que tu as choisi de faire un rapport anonyme, tu renonces à recevoir une notification par e-mail dès que le dossier sera ouvert. Tu ne seras pas non plus informé des autres événements de l'affaire. Grâce aux informations ci-dessous, il te sera toujours possible de revenir en arrière et de suivre l'évolution de l'affaire.",
        responseIngress:
          'Merci pour ton rapport ! Nous traiterons ton dossier dans les plus brefs délais.'
      },
      phoneCall: {
        confirmDescription:
          "À l'étape suivante, un numéro de téléphone à appeler te sera proposé Es-tu sûr de vouloir poursuivre le rapport par téléphone ?",
        createDescription:
          'Tu auras la possibilité de transmettre ton rapport sous forme de message vocal.',
        label: 'Je veux soumettre le rapport par téléphone.',
        message:
          '=== Le rapporteur appellera et laissera son rapport sous forme de message vocal. ===',
        responseDescription:
          'Pour transmettre ton rapport, appelle le numéro de téléphone suivant et laisse un message vocal :',
        responseInstructions1: 'Appelle le numéro de téléphone ci-dessus',
        responseInstructions2: 'Laisse un rapport aussi détaillé que possible',
        responseInstructions3:
          "Si tu souhaites être informé des changements de statut d'une affaire ou d'une nouvelle correspondance, indique ton adresse e-mail ou ton numéro de téléphone dans le rapport.",
        responseInstructions4:
          'Sauvegarde les informations ci-dessous afin de pouvoir revenir en arrière et faire un suivi ici.',
        responseInstructionsHeader: 'Instructions',
        responseTitle: 'Faire un rapport par téléphone',
        responseWarning:
          "Si tu n'as pas laissé de message vocal dans les 7 jours, ton dossier sera automatiquement clos."
      },
      physicalMeeting: {
        confirmDescription:
          "Nous te contacterons à l'adresse {email} concernant ta demande de rapport via une réunion physique. Veux-tu continuer ?",
        createDescription:
          "Nous te laissons la possibilité de déposer ton rapport lors d'une rencontre physique. Pour cela, tu dois indiquer une adresse e-mail que nous utiliserons pour te contacter afin de fixer un rendez-vous.",
        label: "Je veux soumettre le rapport lors d'une réunion physique.",
        message:
          '=== Le rapporteur a demandé une réunion physique pour soumettre le rapport. ===',
        responseDescription:
          "Merci ! Nous te contacterons pour te proposer une date à laquelle nous pourrons nous rencontrer physiquement à l'endroit où tu déposeras ton rapport.  Fais bien attention à sauvegarder les informations suivantes. Tu devras les utiliser si, après la réunion, tu veux suivre l'évolution de ton dossier.",
        responseTitle: 'Demande de rendez-vous envoyée'
      }
    },
    title: 'Signaler un comportement répréhensible chez {organizationTitle}'
  }
}
